import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APIKey  {
    _originalTypeClassName = "zvelton_Backoffice.BO.APIKey";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APIKey.translate = translateService;
}
this.Application = new Domain.Application();
this.Id = null;
this.Name = null;
this.Key = null;
this.Active = false;
this.ActiveUntil = null;
this.CreatedOn = null;
this.LastUsed = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Key:any;
Active:any;
ActiveUntil:any;
CreatedOn:any;
LastUsed:any;
Application:any;
static setApplication = ($this, value) => {
var oldValue = $this.Application;
$this.Application = value;
if (value != null) {
if (oldValue != null) {
Domain.Application.removeKeys(oldValue, $this);
}
Domain.Application.addKeys(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}